import { Link } from "react-router-dom";
import { img, money } from "@/lib/api";

export const totalStock = (p) => Object.values(p.stock || {}).reduce((a, b) => a + Math.max(0, b), 0);

export const ProductCard = ({ product: p, index = 0 }) => {
  const soldOut = !p.preorder && totalStock(p) === 0;
  return (
    <Link to={`/product/${p.slug}`} data-testid={`product-card-${p.slug}`} className={`group block rise d${Math.min(index + 1, 4)}`}>
      <div className="relative aspect-[3/4] overflow-hidden bg-[var(--mm-sand)]">
        <img src={img(p.images?.[0])} alt={p.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-opacity duration-700 group-hover:opacity-0" />
        {p.images?.[1] && <img src={img(p.images[1])} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-0 scale-105 transition-[opacity,transform] duration-700 group-hover:opacity-100 group-hover:scale-100" />}
        <div className="absolute top-3 left-3 flex gap-2">
          {p.preorder && <span data-testid="product-card-preorder-badge" className="eyebrow bg-[var(--mm-red)] text-[var(--mm-cream)] px-2.5 py-1">Pre-order</span>}
          {p.is_new && !soldOut && !p.preorder && <span className="eyebrow bg-[var(--mm-cream)] text-[var(--mm-red)] px-2.5 py-1">New</span>}
          {soldOut && <span className="eyebrow bg-[var(--mm-ink)] text-[var(--mm-cream)] px-2.5 py-1">Sold out</span>}
        </div>
        <div className="absolute bottom-0 inset-x-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-500 hidden sm:block">
          <div className="bg-[var(--mm-cream)]/95 backdrop-blur px-3 py-2.5 flex flex-wrap gap-x-3 gap-y-1 justify-center">
            {p.sizes?.map((s) => (
              <span key={s} className={`text-[0.68rem] tracking-[0.15em] ${p.preorder || (p.stock?.[s] || 0) > 0 ? "" : "line-through opacity-40"}`}>{s}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="pt-4 flex justify-between gap-4">
        <div>
          <h3 data-testid="product-card-name" className="text-[0.78rem] tracking-[0.12em] uppercase font-semibold group-hover:text-[var(--mm-red)] transition-colors">{p.name}</h3>
          <div className="flex gap-1.5 mt-2">
            {p.colours?.map((c) => <span key={c.name} title={c.name} className="w-3 h-3 rounded-full border border-[var(--mm-line)]" style={{ background: c.hex }} />)}
            {p.colours?.length > 0 && <span className="text-[0.7rem] text-[var(--mm-muted)] ml-1">{p.colours.map((c) => c.name).join(" / ")}</span>}
          </div>
        </div>
        <p data-testid="product-card-price" className="text-sm whitespace-nowrap">{money(p.price)}</p>
      </div>
    </Link>
  );
};

export const ComingSoonTile = ({ index = 1 }) => (
  <div data-testid="coming-soon-tile" className={`aspect-[3/4] bg-[var(--mm-red)] text-[var(--mm-cream)] p-8 flex flex-col justify-between relative overflow-hidden grain rise d${Math.min(index + 1, 4)}`}>
    <span className="eyebrow">The next chapter</span>
    <div>
      <p className="font-serif-mm text-4xl leading-none">More pieces,<br /><em>arriving soon.</em></p>
      <p className="text-xs mt-4 opacity-80">Join the letter below to hear first.</p>
    </div>
  </div>
);
